<script lang="ts" setup>
import { inject } from 'vue'
import type { ChapterConfig } from '@/composables/payment'

interface Props {
  chapter: any
  showRecommend: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'prev-chapter'): void
  (e: 'next-chapter'): void
  (e: 'open-toc'): void
  (e: 'unlock-chapter'): void
}>()

const config = inject<ChapterConfig>('chapterConfig')!

function handlePrev() {
  emit('prev-chapter')
}

function handleNext() {
  emit('next-chapter')
}

function handleOpenTOC() {
  emit('open-toc')
}

function handleUnlock() {
  emit('unlock-chapter')
}
</script>

<template>
  <div class="mt-5 flex items-center justify-between">
    <!-- Prev 按钮 -->
    <span
      class="theme-btn-bg w-105px h-39px lh-39px text-center text-14px bg-#0000000A rounded"
      :class="{ 'text-#999': !chapter?.prev }" @click.stop="handlePrev"
    >
      {{ config.texts.prevButton }}
    </span>

    <!-- Catalogue 按钮 -->
    <span class="theme-btn-bg w-100px h-39px lh-39px text-center text-14px bg-#0000000A rounded" @click.stop="handleOpenTOC">
      {{ config.texts.catalogueButton }}
    </span>

    <!-- Next/Unlock 按钮 -->
    <span
      v-if="!showRecommend"
      class="theme-btn-bg w-105px h-39px lh-39px text-center text-14px bg-#0000000A rounded"
      @click.stop="handleNext"
    >
      {{ config.texts.nextButton }}
    </span>
    <span
      v-else
      class="theme-btn-bg w-105px h-39px lh-39px text-center text-14px bg-#0000000A rounded"
      :class="{ 'text-#999': !chapter?.next }"
      @click.stop="handleUnlock"
    >
      {{ config.texts.unlockButton }}
    </span>
  </div>
</template>
